import { CadastroCliente } from '~/pages/PdvOnline/types';

export const resetCadastroCliente: CadastroCliente = {
  des_bairro: '',
  des_complemento: '',
  des_logradouro: '',
  cidades: undefined,
  email: '',
  nome_pessoa: '',
  num_celular: undefined,
  num_cep: '',
  num_cpf: undefined,
  num_cnpj: undefined,
  num_endereco: '',
  num_telefone: undefined,
  tipo_pessoa: '',
  cod_loja: 1,
  flg_endereco_principal: false,
};
